import React from "react";

// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors"

const SubTitle = ({text, className}) => <h5 className={className}>{text}</h5>

SubTitle.defaultProps = {
    text: "SubTitle",
    color: "#000"
}

const SubTitleWithStyles = styled(SubTitle) `
    color: ${(props) => (props.color ? props.color : Colors.text.primary)};
    font-family: "PT Sans";
`

export default SubTitleWithStyles;


// WEBPACK FOOTER //
// ./src/components/subtitle/subtitle.component.js